module.exports = __webpack_public_path__ + "img/activity-tracker-error-screen.b945fef7.webp";